import {
  productFamilyIdFormat,
  productIdFormat,
  supplierIdFormat,
} from "@redotech/redo-model/ids";
import { AdvancedFilterDataSchema } from "@redotech/redo-model/views/views";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

export const SupplierProductRowSchema = z.object({
  id: productIdFormat.schema,
  productFamilyId: productFamilyIdFormat.schema.nullable(),
  title: z.string(),
  sku: z.string().nullable(),
  image: z.string().nullable(),
  cost: z.number().nullable(),
  currency: z.string().nullable(),
  supplierProductTitle: z.string().nullable(),
  supplierSku: z.string().nullable(),
  supplierUnitCost: z.number().nullable(),
  supplierProductCurrency: z.string().nullable(),
  avgPoUnitCost: z.number().nullable(),
  latestPoCost: z.number().nullable(),
});

export const getSupplierProducts = {
  name: "getSupplierProducts" as const,
  input: z.object({
    supplierId: supplierIdFormat.schema,
    page: z.number().int().min(0).default(0),
    pageSize: z.number().int(),
    search: z.string().optional(),
    sortBy: createEnum(["title"]).optional(),
    sortDirection: createEnum(["asc", "desc"]).optional(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).optional(),
  }),
  output: z.array(SupplierProductRowSchema),
};
